<template>
  <div id="home">
    <div class="searchBar">
      <a-input-search
        style="width: 320px"
        placeholder="快速发现答题应用"
        button-text="搜索"
        search-button
        v-model="searchParams.search"
      ></a-input-search>
    </div>
    <a-list
      class="list-demo-action-layout"
      :bordered="false"
      :data="dataList"
      :pagination-props="{
        pageSize: searchParams.pageSize,
        current: searchParams.current,
        total,
      }"
      :grid-props="{ gutter: [20, 20], sm: 24, md: 12, lg: 8, xl: 6 }"
      @page-change="onPageChange"
    >
      <template #item="{ item }"> <AppCard :app="item" /> </template
    ></a-list>
  </div>
</template>

<script lang="ts" setup>
import AppCard from "@/components/AppCard.vue";
import { ref, watchEffect } from "vue";
import API from "@/api";
import { listAppVoByPageUsingPost } from "@/api/appController";
import { Message } from "@arco-design/web-vue";
import { REVIEW_STATUS_ENUM } from "@/constant/app";
import ShareModal from "@/components/ShareModal.vue";

const initSearchParams = { current: 1, pageSize: 12 };
const searchParams = ref<API.UserQueryRequest>({
  ...initSearchParams,
});

const dataList = ref<API.AppVO[]>([]);
const total = ref<number>(0);
const formSearchParams = ref<API.UserQueryRequest>({});

/*
 * 加载数据
 * */
const loadData = async () => {
  const params = {
    reviewStatus: REVIEW_STATUS_ENUM.PASS,
    ...searchParams.value,
  };
  const res = await listAppVoByPageUsingPost(params);
  if (res.data.code === 0) {
    dataList.value = res.data.data?.records || [];
    total.value = res.data.data?.total || 0;
  } else {
    Message.error("获取数据失败，" + res.data.message);
  }
};

/*
 * 监听数据
 * */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/*
 * 执行搜索
 * */
const doSearch = () => {
  searchParams.value = {
    ...initSearchParams,
    ...formSearchParams.value,
  };
};

watchEffect(() => {
  loadData();
});
</script>

<style scoped>
#home {
}

.searchBar {
  text-align: center;
  margin-bottom: 20px;
}

.list-demo-action-layout .image-area {
  width: 183px;
  height: 119px;
  border-radius: 2px;
  overflow: hidden;
}

.list-demo-action-layout .list-demo-item {
  padding: 20px 0;
  border-bottom: 1px solid var(--color-fill-3);
}

.list-demo-action-layout .image-area img {
  width: 100%;
}

.list-demo-action-layout .arco-list-item-action .arco-icon {
  margin: 0 4px;
}
</style>
